<script setup lang="ts">
import { Button } from '@/components/ui/button'

defineProps<{
    open: boolean
}>()

const emit = defineEmits<{
    close: []
}>()

const { t } = useI18n()
</script>

<template>
    <Teleport to="body">
        <Transition
            enter-active-class="transition-opacity duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-if="open"
                class="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/40 p-4"
                @click.self="emit('close')"
            >
                <div
                    class="flex w-full max-w-[400px] flex-col gap-6 rounded-3xl bg-white p-6 shadow-[0_12px_20px_rgba(0,0,0,0.1)]"
                    role="dialog"
                    aria-modal="true"
                    :aria-label="t('Access denied')"
                    @click.stop
                >
                    <div class="flex flex-col gap-2">
                        <h2 class="text-xl font-bold text-neutral-900">
                            {{ $t('Access denied') }}
                        </h2>
                        <p class="text-base text-neutral-400">
                            {{ $t("You don't have permission to view this page.") }}
                        </p>
                    </div>

                    <div class="flex justify-end">
                        <Button
                            size="lg"
                            @click="emit('close')"
                        >
                            {{ $t('OK') }}
                        </Button>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>
